import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useTheme } from '../hooks/useTheme';

interface DataPoint {
  date: string;
  revenue: number;
}

export default function RevenueChart({ data }: { data: DataPoint[] }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const gridColor = isDark ? '#27272a' : '#e4e4e7';
  const axisColor = isDark ? '#71717a' : '#a1a1aa';
  const tooltipBg = isDark ? '#141417' : '#ffffff';
  const tooltipBorder = isDark ? '#27272a' : '#e4e4e7';
  const tooltipText = isDark ? '#e4e4e7' : '#27272a';
  const tooltipLabel = isDark ? '#71717a' : '#71717a';

  if (data.length === 0) {
    return (
      <div
        className="rounded p-6 h-64 flex items-center justify-center"
        style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      >
        <p className="font-sans text-sm" style={{ color: 'var(--dash-text-muted)' }}>No revenue data yet</p>
      </div>
    );
  }

  return (
    <div
      className="rounded p-6"
      style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
    >
      <div className="font-mono text-[10px] uppercase tracking-widest mb-4" style={{ color: 'var(--dash-text-muted)' }}>
        Revenue — Last 30 Days
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 10, fontFamily: '"IBM Plex Mono"', fill: axisColor }}
            stroke={gridColor}
          />
          <YAxis
            tick={{ fontSize: 10, fontFamily: '"IBM Plex Mono"', fill: axisColor }}
            stroke={gridColor}
            tickFormatter={(v) => `$${v}`}
          />
          <Tooltip
            contentStyle={{
              background: tooltipBg,
              border: `1px solid ${tooltipBorder}`,
              borderRadius: '4px',
              fontFamily: '"IBM Plex Mono"',
              fontSize: 12,
              color: tooltipText,
            }}
            labelStyle={{ color: tooltipLabel }}
            formatter={(value) => [`$${Number(value).toFixed(2)}`, 'Revenue']}
          />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#3b82f6"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
